module.exports = __webpack_public_path__ + "img/carshina21_01.c8c22901.jpg";